const { client, loadToken } = require('./client');
export { loadToken };


export async function getEventReport(id, groups, options) {
    var { data } = await client.get(`/reports/event/${id}/${groups}`, options);
    return data;
}

export async function getLiveviewReport(uuid, start_time, options) {
    var { data } = await client.get(`/reports/device/${uuid}/${start_time}`, options);
    return data;
}

export async function getLiveviewHistoryReport(uuid, start_time, end_time, options) {
    var { data } = await client.get(`/reports/device/${uuid}/${start_time}/${end_time}`, options);
    return data;
}

export async function getCameraObjectsReport(uuid, start_time, end_time, options, body) {
    var { data } = await client.post(`/reports/camera/objects/${uuid}/${start_time}/${end_time}`, body, options);
    return data;
}

export async function getCameraObjectsData(uuid, start_time, end_time, body) {
    var { data } = await client.post(`/reports/camera/data/${uuid}/${start_time}/${end_time}`, body);
    return data;
}

export async function generateMonthlyInspectionReport(start_time, end_time, body, options) {
    var { data } = await client.post(`/reports/inspections/${start_time}/${end_time}`, body, options);
    return data;
}

export async function errorLog(error_data) {
    var { data } = await client.post('/reports/errors', error_data);
    return data;
}

const all = {
    loadToken, getEventReport, getLiveviewReport, getLiveviewHistoryReport, getCameraObjectsReport, getCameraObjectsData, generateMonthlyInspectionReport, errorLog
};

export default all;